import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import { formatDateTime } from "../../../utils/helper";
import ImageViewer from "../../../components/ImageViewer";
import ConfirmationDlg from "../../../components/ConfirmationDlg";

function AlertResult({ alarm, suspected }) {
  const [comments, setComments] = useState([]);
  const [comments2, setComments2] = useState([]);
  const [comment, setComment] = useState("");
  const [comment2, setComment2] = useState("");
  const [liked, setLiked] = useState(false);
  const [dislike, setDislike] = useState(false);
  const [liked2, setLiked2] = useState(false);
  const [dislike2, setDislike2] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [showComment2, setShowComment2] = useState(false);
  const [openModalVa, setOpenModalVa] = useState("");
  const [openModalGina, setOpenModalGina] = useState("");
  const toggleLike = () => {
    if (!liked) {
      setOpenModalVa("Like");
    } else {
      setLiked(!liked);
    }
  };
  const toggleDislike = () => {
    if (!dislike) {
      setOpenModalVa("Dislike");
    } else {
      setDislike(!dislike);
    }
  };
  const submitVa = () => {
    if (openModalVa === "Like") {
      setLiked(true);
    } else {
      setDislike(true);
    }
    setOpenModalVa("");
  };

  const toggleComment = () => {
    setShowComment(!showComment);
  };

  const addComment = async () => {
    if (comment) {
      setComments([...comments, { comment: comment, created_at: new Date() }]);
      setComment("");
    }
  };
  const toggleLike2 = () => {
    if (!liked2) {
      setOpenModalGina("Like");
    } else {
      setLiked2(!liked2);
    }
  };
  const toggleDislike2 = () => {
    if (!dislike2) {
      setOpenModalGina("Dislike");
    } else {
      setDislike2(!dislike2);
    }
  };

  const toggleComment2 = () => {
    setShowComment2(!showComment2);
  };
  const submitGina = () => {
    if (openModalGina === "Like") {
      setLiked2(true);
    } else {
      setDislike2(true);
    }
    setOpenModalGina("");
  };

  const addComment2 = async () => {
    if (comment2) {
      setComments2([
        ...comments2,
        { comment: comment2, created_at: new Date() },
      ]);
      setComment2("");
    }
  };
  return (
    <div>
      <ConfirmationDlg
        open={openModalVa}
        btnCancelText={"Cancel"}
        btnSubmitText={"Submit"}
        onClose={() => setOpenModalVa("")}
        onSubmit={submitVa}
        title={`Confirm`}
      >
        <div>
          Please provide some comments relating to your{" "}
          {openModalVa === "Like" ? "agreement" : "disagreement"} with this
          analysis{" "}
        </div>
        <input
          style={{
            width: "100%",
            padding: "5px",
          }}
          type={"text"}
          placeholder={"Write Your Comment Here"}
        />
      </ConfirmationDlg>
      <ConfirmationDlg
        open={openModalGina}
        btnCancelText={"Cancel"}
        btnSubmitText={"Submit"}
        onClose={() => setOpenModalGina("")}
        onSubmit={submitGina}
        title={`You have ${openModalGina} this feedback`}
      >
        Please provide some comments relating to your{" "}
        {openModalGina === "Like" ? "agreement" : "disagreement"} with this
        analysis{" "}
        <input
          style={{
            width: "100%",
            padding: "5px",
          }}
          type={"text"}
          placeholder={"Write Your Comment Here"}
        />
        <div style={{ marginTop: "10px" }}>
          Which suspected issue are{" "}
          {openModalGina === "Like" ? "Correct" : "Incorrect"}?
        </div>
        {suspected.map((item, index) => (
          <div key={index}>
            <input
              type="checkbox"
              id={item.name}
              name={item.name}
              value={item.name}
            />
            <label htmlFor={item.name}>{item.name}</label>
          </div>
        ))}
      </ConfirmationDlg>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
          <img
            src="/assets/img/user/va_jacob.jpg"
            className={"va-profile"}
            alt=""
          />
          <div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: "bold",
              }}
            >
              Alex Jacobs
            </div>
            <div style={{ fontSize: "11px" }}>
              Vibration measurement & analysis engineer
            </div>
            <div style={{ fontSize: "11px" }}>
              Mobius Institute, Certified Vibration Analyst - Category III
            </div>
          </div>
        </CardHeader>
        <CardBody className="card-body pb-2">
          {alarm ? (
            <div>
              Looking at the FFT of the vibrations indicate that a portion of
              the vibrations is coming from the 2X (50 Hz). Sometimes this can
              indicate a misalignment between the electric motor and the
              gearbox. The customer is recommended to check this and if possible
              reduce the amount of the misalignment between the motor and
              gearbox.
            </div>
          ) : null}
          <ImageViewer
            disableBox={true}
            size={"xl"}
            staticImage={"/assets/img/va_chart.png"}
          ></ImageViewer>
        </CardBody>
        <CardFooter
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
            }}
          >
            <div
              className="faa-parent animated-hover btn-upvote"
              style={{
                color: liked ? "#53c6ff" : "#ced2d4",
                marginRight: "10px",
              }}
              onClick={toggleLike}
            >
              <i className="fa fa-thumbs-up faa-bounce"></i> Agree
            </div>
            <div
              className="faa-parent animated-hover btn-upvote "
              style={{ color: dislike ? "#53c6ff" : "#ced2d4" }}
              onClick={toggleDislike}
            >
              <i className="fa fa-thumbs-down faa-bounce faa-reverse"></i>{" "}
              Disagree
            </div>
          </div>

          <div
            className="faa-parent animated-hover btn-upvote"
            style={{ color: showComment ? "#53c6ff" : "#ced2d4" }}
            onClick={toggleComment}
          >
            <i className="fa fa-comment faa-shake"></i> Comment
          </div>
        </CardFooter>
        {showComment && (
          <CardFooter>
            <div style={{ display: "flex" }}>
              <input
                style={{
                  width: "80%",
                  padding: "5px",
                }}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                type="text"
                placeholder={"Write Your Comment Here"}
              />
              <button
                onClick={addComment}
                className={"btn btn-outline-theme"}
                style={{ marginLeft: "4px" }}
              >
                <i className="fa fa-paper-plane"></i> Submit
              </button>
            </div>
            <div style={{ height: "20px" }}></div>
            {comments.map((cm, index) => (
              <div style={{ display: "flex", marginTop: "9px" }} key={index}>
                <div className={"profile-name"}>US</div>
                <div
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Demo User
                  </div>
                  <div>
                    {cm.comment} - {formatDateTime(cm.created_at)}
                  </div>
                </div>
              </div>
            ))}
          </CardFooter>
        )}
      </Card>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
          <div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: "bold",
              }}
            >
              GINA AI
            </div>
          </div>
        </CardHeader>
        <CardBody className="card-body pb-2">
          {alarm ? (
            <div>
              <p>{alarm?.alert_finding}</p>
            </div>
          ) : null}
          <hr />
          <div>Suspected Issue</div>
          <div className="accordion" id="accordionSuspect">
            {suspected.map((item, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    style={{ padding: "5px" }}
                    data-bs-target={`#collapseSuspect${index}`}
                  >
                    {item.name}
                  </button>
                </h2>
                <div
                  id={`collapseSuspect${index}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionSuspect"
                >
                  <div className="accordion-body">
                    <div style={{ fontWeight: "bold" }}>
                      GINA.AI RECOMMENDATIONS:
                    </div>
                    <ul>
                      {item.recommended_action.map((ra, index) => (
                        <li key={index}>{ra}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardBody>
        <CardFooter
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex" }}>
            <div
              className="faa-parent animated-hover btn-upvote"
              style={{
                color: liked2 ? "#53c6ff" : "#ced2d4",
                marginRight: "10px",
              }}
              onClick={toggleLike2}
            >
              <i className="fa fa-thumbs-up faa-bounce"></i> Agree
            </div>
            <div
              className="faa-parent animated-hover btn-upvote "
              style={{ color: dislike2 ? "#53c6ff" : "#ced2d4" }}
              onClick={toggleDislike2}
            >
              <i className="fa fa-thumbs-down faa-bounce faa-reverse"></i>{" "}
              Disagree
            </div>
          </div>

          <div
            className="faa-parent animated-hover btn-upvote"
            style={{ color: showComment2 ? "#53c6ff" : "#ced2d4" }}
            onClick={toggleComment2}
          >
            <i className="fa fa-comment faa-shake"></i> Comment
          </div>
        </CardFooter>
        {showComment2 && (
          <CardFooter>
            <div style={{ display: "flex" }}>
              <input
                style={{
                  width: "80%",
                  padding: "5px",
                }}
                value={comment2}
                onChange={(e) => setComment2(e.target.value)}
                type="text"
                placeholder={"Write Your Comment Here"}
              />
              <button
                onClick={addComment2}
                className={"btn btn-outline-theme"}
                style={{ marginLeft: "4px" }}
              >
                <i className="fa fa-paper-plane"></i> Submit
              </button>
            </div>
            <div style={{ height: "20px" }}></div>
            {comments2.map((cm, index) => (
              <div style={{ display: "flex", marginTop: "9px" }} key={index}>
                <div className={"profile-name"}>US</div>
                <div
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Demo User
                  </div>
                  <div>
                    {cm.comment} - {formatDateTime(cm.created_at)}
                  </div>
                </div>
              </div>
            ))}
          </CardFooter>
        )}
      </Card>
    </div>
  );
}
export default AlertResult;
